<template>
    <div class="scientific_data_wrap">
        <div class="banner flex-justify-content">
            <div>
                <div class="banner_title">科研合作数据</div>
                <div>与各项高校及研究机构合作研发的特色数据资源</div>
            </div>
        </div>
        <div class='dataClassification'>
            <div class='dataClassification-item' v-for='(item,index) in collaborativeData1List' :class='"bg"+(index+1)'
                 @click='goDetail(index)'>
                <div class='dataClassification-content'>
                    <div class="item_title">{{ item.title }}</div>
                    <div>
                        <el-button class="mouse-hover" plain round>了解详情</el-button>
                    </div>
                </div>
            </div>

        </div>
        <div class="exhibition_wrap">
            <div class="line flex-between">
                <div class="exhibition_content">
                    <div class="exhibition_title">科创板 IPO 问询数据</div>
                    <div class="exhibition_text">
                        科创板（http://kcb.sse.com.cn/renewal/）股票审核数据来源于项目动态为发行上市的所有数据和公司详细信息中的受理和问询日期等，以及项目基本信息；问询回复数据来源于公司详细信息中问询与回复板块文件开头8-1的pdf文件提取的数据；招股说明书数据来源于信息披露板块中披露文件提取数据。
                    </div>
                </div>
                <div class="img_wrap">
                    <img src='../../../assets/img/scientific_img_one.png' alt="">
                </div>
            </div>
            <div class="line flex-between">
                <div class="img_wrap">
                    <img src='../../../assets/img/scientific_img_two.png' alt="">
                </div>
                <div class="exhibition_content">
                    <div class="exhibition_title">创业板 IPO 问询数据</div>
                    <div class="exhibition_text">创业板（http://listing.szse.cn/projectdynamic/ipo/index.html）
                        股票审核数据来源于项目动态为IPO的所有数据和公司详细信息中的受理和问询日期等，以及项目基本信息；问询回复数据来源于公司详细信息中问询与回复板块文件开头8-1的pdf文件提取的数据；招股说明书数据来源于信息披露板块中披露文件提取数据。
                    </div>
                </div>
            </div>
            <div class="line flex-between">
                <div class="exhibition_content">
                    <div class="exhibition_title">“天府粮仓”定制数据</div>
                    <div class="exhibition_text">
                        包括农业生产数据（种植作物的品种、面积、产量等信息，以及畜牧业、渔业等方面的数据）、粮食产量数据（小麦、玉米、水稻、高粱等粮食作物的年度产量数据）、气象数据（该气温、降水、风力等气象数据，以及极端天气等方面的数据）、农业政策数据（政府针对该地区农业发展制定的各种政策文件、政策实施情况、政策效果等数据）。
                    </div>
                </div>
                <div class="img_wrap">
                    <img src='../../../assets/img/scientific_img_three.png' alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            collaborativeData1List: [
                {
                    title: '科创板 IPO 问询数据',
                    pageId: 1,
                    name: '科创板IPO问询数据'
                },
                {
                    title: '创业板 IPO 问询数据',
                    pageId: 2,
                    name: ''
                },
                {
                    title: '银行金融科技指数',
                    pageId: 3,
                    name: ''
                },
                {
                    title: '股票因子数据库',
                    pageId: 4,
                    name: ''
                }, {
                    title: '工业产业特色数据库',
                    pageId: -1,
                    name: ''
                },
                {
                    title: '医学康养特色数据库',
                    pageId: -1,
                    name: ''
                },
                {
                    title: '武侯区数字经济发展指标监测体系数据库',
                    pageId: 5,
                    name: ''
                },
                {
                    title: '武侯区数字经济发展考核评价体系数据库',
                    pageId: 6,
                    name: ''
                },
                {
                    title: '其他领域特色数据库',
                    pageId: -1,
                    name: ''
                }

            ]
        };
    },
    created() {
    },
    methods: {
        goDetail(index) {
            if (this.collaborativeData1List[index].pageId === -1) return this.$message.info('暂未开放');
            this.$store.commit('setPageId', { pageId: this.collaborativeData1List[index].pageId });
            this.$router.push(`/researchData?name=${this.collaborativeData1List[index].name}`);
        }
    }
};
</script>
<style lang='scss' scoped>
.exhibition_wrap {
    width: 100vw;
    padding: 0px 120px;
    margin-top: 10px;
    box-sizing: border-box;
    background: url('../../../assets/img/scientific_bg.png') 0 0/100% 100% no-repeat;

    .line {
        .exhibition_content {
            .exhibition_title {
                margin-bottom: 25px;
                font-size: 20px;
                font-weight: bold;
                color: #3C3C3C;
            }

            text-align: justify;
            line-height: 1.7;
            color: #999999;
            width: 45%;
            padding: 0px 60px;
        }

        .img_wrap {
            width: 40%;
            height: 550px;
            padding: 30px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        &:nth-of-type(3) {
            .img_wrap {
                height: 500px;
            }

        }
    }
}

.dataClassification {
    width: 100vw;
    box-sizing: border-box;
    padding: 40px 10%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 28px;

    .dataClassification-item {
        width: 512px;
        height: 152px;
        position: relative;
        transition: all .2s;
        cursor: pointer;

        .item_title {
            font-size: 20px;
            font-family: Microsoft YaHei, serif;
            font-weight: 400;
            line-height: 26px;
            margin-bottom: 20px;
            color: #000;
        }

        &:hover {
            .item_title {
                color: #fff;
            }
        }

        .dataClassification-content {
            margin-top: 30px;
            margin-left: 30px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 999;
        }
    }

    .bg1 {
        background-image: url("../../../assets/img/collaborativeData-white1.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData1.png");
        }
    }

    .bg2 {
        background-image: url("../../../assets/img/collaborativeData-white2.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData2.png");
        }
    }

    .bg3 {
        background-image: url("../../../assets/img/collaborativeData-white3.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData3.png");
        }
    }

    .bg4 {
        background-image: url("../../../assets/img/collaborativeData-white1.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData1.png");
        }
    }

    .bg5 {
        background-image: url("../../../assets/img/collaborativeData-white4.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData4.png");
        }
    }

    .bg6 {
        background-image: url("../../../assets/img/collaborativeData-white5.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData5.png");
        }
    }

    .bg7 {
        background-image: url("../../../assets/img/collaborativeData-white1.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData1.png");
        }
    }

    .bg8 {
        background-image: url("../../../assets/img/collaborativeData-white1.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData1.png");
        }
    }

    .bg9 {
        background-image: url("../../../assets/img/collaborativeData-white6.png");
        background-size: 100% 100%;
        transition: all 0.2s;

        &:hover {
            background-image: url("../../../assets/img/collaborativeData6.png");
        }
    }

}

.scientific_data_list {
    width: 100vw;
    box-sizing: border-box;
    padding: 40px 10%;

    > div {
        width: 43%;
        box-sizing: border-box;
        padding: 36px 85px;
        height: 172px;
        color: #333333;

        .item_title {
            font-size: 20px;
            margin-bottom: 30px;
        }
    }
}

.banner {
    height: 60vh;
    color: #ccc;
    font-size: 20px;
    background: url('../../../assets/img/scientific_banner.png') 0 0/100% 100% no-repeat;

    > div {
        text-align: center;
    }

    .banner_title {
        font-size: 45px;
        font-weight: bold;
        color: white;
        margin-bottom: 25px;
        letter-spacing: 2px;
    }
}
</style>
